import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import WhyHostForm from '../../../components/siteadmin/WhyHostForm/WhyHostForm';
import Loader from '../../../components/Loader/Loader';
import getWhyHostData from './getWhyHostData.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import s from './WhyHost.css';

const WhyHost = (props) => {
  const { getWhyHostData: { loading, getWhyHostData }, title } = props;

  let initialValues = {
    dataList: [{
      imageName: null,
      title: null,
      buttonLabel: null,
      dynamicWhyHost: [{ language: 'en', title: '', buttonLabel: '' }]
    }]
  };

  if (getWhyHostData && getWhyHostData.dataList && getWhyHostData.dataList.length > 0) {
    initialValues = {
      dataList: getWhyHostData.dataList.map(item => ({
        id: item.id || null,
        imageName: item.imageName || null,
        title: item.title || null,
        buttonLabel: item.buttonLabel || null,
        dynamicWhyHost: item.dynamicWhyHost?.length > 0
          ? item.dynamicWhyHost.map(d => ({
            language: d.language,
            title: d.title,
            buttonLabel: d.buttonLabel
          }))
          : [{ language: 'en', title: item.title || '', buttonLabel: item.buttonLabel || '' }]
      }))
    };
  }

  if (loading) {
    return <Loader type={"text"} />;
  } else {
    return !loading && <WhyHostForm title={title} initialValues={initialValues} />;
  }
};

export default compose(
  withStyles(s),
  withQuery(getWhyHostData, {
    name: 'getWhyHostData',
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  })
)(WhyHost);